import cat from './images/cat.jpg';
import cat1 from './images/cat1.jpeg';
import cat2 from './images/cat2.jpeg';
import cat3 from './images/cat3.jpeg';
import cat4 from './images/cat4.jpeg';
import cat5 from './images/cat5.jpeg';
import cat6 from './images/cat6.jpeg';
import cat7 from './images/cat7.jpeg';
import cat8 from './images/cat8.jpeg';
import cat9 from './images/cat9.jpeg';
import cat10 from './images/cat10.jpeg';
import cat11 from './images/cat11.jpeg';


const cats_arr = [
    {
        name: "cat",
        clicked: false,
        imgUrl: cat,
        key: 0
    },
    {
        name: "cat1",
        clicked: false,
        imgUrl: cat1,
        key: 1
    },
    {
        name: "cat2",
        clicked: false,
        imgUrl: cat2,
        key: 2
    },
    {
        name: "cat3",
        clicked: false,
        imgUrl: cat3,
        key: 3
    },
    {
        name: "cat4",
        clicked: false,
        imgUrl: cat4,
        key: 4
    },
    {
        name: "cat5",
        clicked: false,
        imgUrl: cat5,
        key: 5
    },
    {
        name: "cat6",
        clicked: false,
        imgUrl: cat6,
        key: 6
    },
    {
        name: "cat7",
        clicked: false,
        imgUrl: cat7,
        key: 7
    },
    {
        name: "cat8",
        clicked: false,
        imgUrl: cat8,
        key: 8
    },
    {
        name: "cat9",
        clicked: false,
        imgUrl: cat9,
        key: 9
    },
    {
        name: "cat1",
        clicked: false,
        imgUrl: cat10,
        key: 10
    },
    {
        name: "cat11",
        clicked: false,
        imgUrl: cat11,
        key: 11
    }
]


export default cats_arr; 


// WEBPACK FOOTER //
// ./src/cat.js